var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "525px",
    height: "525px",
    viewBox: "0 0 525 525",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "protein_plant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "protein_plant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-leaf-1354335",
    transform: "translate(134.794351, 133.549723)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8898AA",
    strokeWidth: 20,
    cx: 263,
    cy: 263,
    r: 240
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.574951,244.698725 C245.453422,294.693998 191.718198,342.015105 176.68388,422.549723 C235.115688,382.215245 312.417796,372.654678 353.38041,323.884714 C395.652294,273.573537 388.154026,203.987996 390.451942,133.549723 C341.267944,156.659542 292.547833,169.468886 242.695818,180.798413 C147.294805,202.483514 106.935664,305.171318 155.323603,400.614312 C208.932885,304.730521 247.822704,262.996513 305.582823,244.703448 L305.574951,244.698725 Z",
    id: "Path",
    fill: "#8898AA",
    fillRule: "nonzero",
    transform: "translate(262.623146, 278.049723) rotate(-6.000000) translate(-262.623146, -278.049723) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinPlant);
export default __webpack_public_path__ + "static/media/protein_plant.64155b18f15f634b18ea23ea51bc383e.svg";
export { ForwardRef as ReactComponent };